const BASE_URL = "https://blackroth.in";

export const buildServiceSchema = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  provider: {
    "@type": "Organization",
    name: "BlackRoth",
  },
  url: `${BASE_URL}${path}`,
});
